<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <mask id="delete" maskUnits="userSpaceOnUse" x="2" y="0" width="20" height="24">
            <path
                d="M22 4V2h-5l-1.688-2H8.689L7 2H2v2h20zm-4.688 20c.709 0 1.334-.27 1.875-.813.542-.541.813-1.166.813-1.875V6H4v15.313c0 .708.27 1.333.813 1.875.541.541 1.166.812 1.875.812h10.625z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#delete)">
            <path
                d="M22 4V2h-5l-1.688-2H8.689L7 2H2v2h20zm-4.688 20c.709 0 1.334-.27 1.875-.813.542-.541.813-1.166.813-1.875V6H4v15.313c0 .708.27 1.333.813 1.875.541.541 1.166.812 1.875.812h10.625z"
            />
            <path d="M41.111-17.778h-56.889v56.89h56.89v-56.89z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'DeleteSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
